export const Categorys = [
    {
        id: 1,
        slug: "noticias",
        title: "Notícias"
    },
    {
        id: 5,
        slug: "musica",
        title: "Música"
    },
    {
        id: 7,
        slug: "cinema",
        title: "Cinema"
    },
    {
        id: 8,
        slug: "Séries",
        title: "Séries"
    }, {
        id: 3,
        slug: "tecnologia",
        title: "Tecnologia"
    }, {
        id: 6,
        slug: "tv-e-celebridades",
        title: "Tv e Celebridades"
    }, {
        id: 12,
        slug: "sp",
        title: "SP"
    }, {
        id: 15,
        slug: "novelas",
        title: "Novelas"
    }
]